module.exports = __webpack_public_path__ + "img/ahorcado1.fd640c63.jpg";